import type { DropdownItemVariant } from "./types";

type ItemAccessibilityContext = {
  label?: string;
  accessibilityLabel?: string;
  variant?: DropdownItemVariant;
};

/**
 * A caller's `accessibilityLabel` is the name as given, so it can say a
 * destructive item's intent in its own words; an empty one leaves the item
 * named by its visible text. A name taken from `label` gets the
 * ", destructive action" suffix (Dropdown #11).
 */
export function getItemAccessibilityLabel({
  label,
  accessibilityLabel,
  variant,
}: ItemAccessibilityContext): string | undefined {
  if (accessibilityLabel !== undefined) return accessibilityLabel || undefined;
  if (!label) return undefined;
  // i18n: dropdown.destructiveSuffix
  return variant === "destructive" ? `${label}, destructive action` : label;
}

export function getItemColor(
  disabled: boolean | undefined,
  variant: DropdownItemVariant | undefined,
): "neutral-foreground-attenuated" | "system-danger-default" | "neutral-foreground-default" {
  if (disabled) return "neutral-foreground-attenuated";
  return variant === "destructive" ? "system-danger-default" : "neutral-foreground-default";
}
